import { render, staticRenderFns } from "./TenantEditEmail.vue?vue&type=template&id=4c687824&"
import script from "./TenantEditEmail.vue?vue&type=script&lang=js&"
export * from "./TenantEditEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports